module.exports = __webpack_public_path__ + "static/media/posgrados_trabajo_grado.8149d3b0.png";